import React, { useState, useRef, useEffect, useContext } from "react";
import Servicios from "../components/Servicios";
import BusquedaTiendaV2 from "../components/BusquedaTiendaV2";
import MapaGoogle from "../components/MapaGoogle";
import Calendario from "../components/Calendario";
import PropositoCita from "../components/PropositoCita";
import DatosPersonales from "../components/DatosPersonales";
import Resumen from "../components/Resumen";
import Reagendar from "../pages/Reprogramar"; // Componente Reagendar
import { FormContext } from "../context/FormContext"; // Importar el contexto
import StepIndicator from "../components/StepIndicator";
import InfoInicio from "../components/Headers/InfoInicio";
import TiendaSeleccionada from "../components/TiendaSeleccionada";
import TiendaSeleccionadaReagendamiento from "../components/Reagendamiento/TiendaSeleccionadaReagendamiento";
import ResumenExamen from "../components/ResumenExamen";
import ResumenExamenReagendamiento from "../components/Reagendamiento/ResumenExamenReagendamiento";
import CancelarReserva from "../components/Cancelamiento/cancelarReserva";
import ReagendamientoReserva from "../components/Reagendamiento/ReagendamientoReserva";
import CalendarioReagendamiento from "../components/Reagendamiento/CalendarioReagendamiento";
import ResumenReagendamiento from "../components/Reagendamiento/ResumenReagendamiento";
import { useParams, useLocation } from "react-router-dom";
import gmoLogo from "../assets/images/gmo_logo.png";
import opvLogo from "../assets/images/opticas-opv-logo.avif";
import ecoLogo from "../assets/images/logo.svg";

const Reserva = () => {
  const { formData, updateFormData, resetFormData } = useContext(FormContext);
  const [step, setStep] = useState(formData.currentStep || 1);
  const [subStep, setSubStep] = useState(1); // Controla los sub-steps del step 6
  const [datosReserva, setDatosReserva] = useState(null);
  const [headerStep, setHeaderStep] = useState(
    formData.currentStep >= 5 ? 3 : 1
  );
  const [mapaCenter, setMapaCenter] = useState({
    lat: null, // Inicia vacío
    lng: null, // Inicia vacío
  });
  
  useEffect(() => {
    if (formData?.pais === "cl") {
      setMapaCenter({
        lat: -33.4123,
        lng: -70.6069,
      });
    } else {
      setMapaCenter({
        lat: null, // Vacío cuando no es "cl"
        lng: null, // Vacío cuando no es "cl"
      });
    }
  }, [formData?.pais]);


  // Datos del contexto para configuración del mapa
  // console.log("FORM DATA MAPA" , formData)
  const marcadorRef = useRef(null);

  // Estado para almacenar la cadena y el país
  const [cadenaNombre, setCadenaNombre] = useState("");
  const [paisNombre, setPaisNombre] = useState("");

  // Obtener la ruta actual y extraer `{cadena}-{pais}`
  const location = useLocation();
  const pathname = location.pathname.replace("/", ""); // Eliminar la barra inicial
  const pathParts = pathname.split("-"); // Separar "cadena-pais"
  const cadena = pathParts[0] || ""; // Extraer cadena
  const pais = pathParts[1] || ""; // Extraer país

  // Actualizar el estado y contexto con `cadena` y `pais`
  useEffect(() => {
    if (cadena && pais) {
      setCadenaNombre(cadena);
      setPaisNombre(pais);

      updateFormData({
        cadena: cadena,
        pais: pais,
      });

      // Parámetros extraídos de la URL para configuración inicial
      // console.log("🚀 Parámetros extraídos de la URL en duro:", {
      //   cadena,
      //   pais,
      // });
      // console.log("📦 Datos actualizados en el contexto:", { cadena, pais });
    } else {
      // Advertencia: no se pudieron extraer parámetros de la URL
      console.warn("❌ No se pudieron extraer los valores de la URL.");
    }
  }, [cadena, pais]);

  const actualizarMapaCenter = (nuevasCoordenadas) => {
    setMapaCenter(nuevasCoordenadas);
    marcadorRef.current = nuevasCoordenadas;
  };

  const nextStep = () => {
    setStep((prevStep) => {
      const newStep = prevStep + 1;
      updateFormData({ currentStep: newStep });
      if (newStep < 5) setHeaderStep(2);
      if (newStep === 5) setHeaderStep(3);
      return newStep;
    });
  };

  const prevStep = () => {
    setStep((prevStep) => {
      const newStep = prevStep - 1;
      updateFormData({ currentStep: newStep });
      if (newStep < 5) setHeaderStep(2);
      return newStep;
    });
  };

  const goToStep = (newStep) => {
    setStep(newStep);
    updateFormData({ currentStep: newStep });
  };

  const goToSubStep = (newSubStep) => {
    setSubStep(newSubStep);
  };

  const nextSubStep = () => {
    setSubStep((prevSubStep) => prevSubStep + 1);
  };

  const prevSubStep = () => {
    if (subStep > 1) {
      setSubStep((prevSubStep) => {
        // console.log("Returning to previous sub-step:", prevSubStep - 1);
        return prevSubStep - 1;
      });
    } else {
      // console.log("Returning to step 1 from subStep:", subStep);
      setStep(1); // Reset to step 1
      setSubStep(1); // Reset subStep to 1
    }
  };
  useEffect(() => {
    if (step === 1 && marcadorRef.current) {
      setMapaCenter(marcadorRef.current);
    }
    // console.log("Paso actual:", step);
    // console.log("Sub-paso actual:", subStep);
  }, [step, subStep]);


  useEffect(() => {
    // Validar si formData?.cadena tiene un valor permitido
    const allowedThemes = ["opv", "eco", "gmo"];
    const themeClass = allowedThemes.includes(formData?.cadena) ? `${formData.cadena}-theme` : null;
  
    // Remover solo las clases que pueden haber sido agregadas previamente
    document.body.classList.remove("opv-theme", "eco-theme", "gmo-theme");
  
    // Agregar la nueva clase si es válida
    if (themeClass) {
      document.body.classList.add(themeClass);
    }
  
    // Limpiar la clase cuando el componente se desmonte
    return () => {
      if (themeClass) {
        document.body.classList.remove(themeClass);
      }
    };
  }, [formData?.cadena]);
  

  const logos = {
    opv: opvLogo, // Para formData.cadena === "opv"
    eco: ecoLogo, // Para formData.cadena === "eco"
    default: gmoLogo, // Para cualquier otro valor
  };

  const selectedLogo = logos[formData?.cadena] || logos.default;
  return (
    <>
      {formData?.cadena === "eco" ? (
        <>
          {step === 1 && (
            <div className="container">
              <div className="row">
                <div className="row mb20" id="booking-intro-head">
                  <div className="col-12 pads30 pads10-768 mb20 mt20">
                    <div className="row d-flex align-items-center">
                      <div className="col-auto">
                        <img
                          src={selectedLogo}
                          alt="GMO logo"
                          className="img-fluid"
                          style={{ maxWidth: "100px", maxHeight: "30px" }}
                        />
                      </div>
                      <div className="col">
                        <h1 className="upper monts-l">
                          <span className="monts-b">
                            Programe un examen de la vista
                          </span>{" "}
                          para usted y su familia
                        </h1>
                        <p>
                          Reserve su fecha y horario preferido en su tienda más
                          cercana
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {step >= 2 && (
            <div className="row" id="booking-header">
              <StepIndicator step={headerStep} />
            </div>
          )}

          {step === 1 && (
            <div className="row" id="step-find">
              <div className="container pads0-768">
                <div className="row">
                  <div className="col-12">
                    <div className="row justify-content-center">
                      <div className="col-md-8 col-12 pads0">
                        <div className="row mb20">
                          <BusquedaTiendaV2
                            onProgramarExamen={nextStep}
                            actualizarMapaCenter={actualizarMapaCenter}
                          />
                          <MapaGoogle
                            center={mapaCenter}
                            marcador={marcadorRef.current}
                          />
                        </div>
                      </div>

                      <div className="col-md-4 mb40-768 pads0-768">
                        <Servicios />
                        <div className="row">
                          <div className="col-12 mb20">
                            <p className="mb0">
                              <i>
                                Si ya tienes una cita agendada y necesitas
                                reprogramarla o anularla, puedes hacerlo aquí:
                              </i>
                            </p>
                          </div>
                          <div className="col-6">
                            <div
                              className="src-button-eco search-button search-button-resch upper"
                              onClick={() => goToStep(7)}
                            >
                              Reagendar cita
                            </div>
                          </div>
                          <div className="col-6">
                            <div
                              className="src-button-eco search-button search-button-cancel upper"
                              onClick={() => goToStep(8)}
                            >
                              Anular cita
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {step > 1 && step < 5 && (
            <div className="row" id="booking">
              <div className="container">
                <div className="row mb40" id="booking-step-back">
                  <button className="volver-step1" onClick={prevStep}>
                    <i className="fa fa-long-arrow-left"></i>
                    &nbsp; VOLVER
                  </button>
                </div>
                <div className="row justify-content-center">

                <div className="col-md-3 col-12 mt20-768" id="booking-resume">
                    <div className="row">
                      <div className="col-12 pads0 pads10-768 mobile-booking-tab-container">
                        <TiendaSeleccionada />
                        {step === 3 || step === 4 ? <ResumenExamen /> : null}
                      </div>
                    </div>
                  </div>


                  {step === 2 && (
                    <PropositoCita onPropositoSeleccionado={nextStep} />
                  )}
                  {step === 3 && (
                    <Calendario onCalendarioSeleccionado={nextStep} />
                  )}
                  {step === 4 && (
                    <DatosPersonales onDatosPersonalesSeleccionado={nextStep} />
                  )}
                  <div
                    className="col-md-3 col-12 mb40-768 pads0-768"
                    id="info-sidebar"
                  >
                    <Servicios />
                  </div>

                </div>
              </div>
            </div>
          )}

          {step === 5 && (
            <div className="row" id="booking">
              <div className="container">
                <div className="row mb40" id="booking-step-back">
                  <button className="volver-step1" onClick={prevStep}>
                    <i className="fa fa-long-arrow-left"></i>
                    &nbsp; VOLVER
                  </button>
                </div>
                <div className="row justify-content-center">
                  <Resumen
                    onResumenSeleccionado={nextStep}
                    onVolver={prevStep}
                  />
                </div>
              </div>
            </div>
          )}

          {step === 7 && (
            <>
              {subStep === 1 && (
                <Reagendar
                  nextStep={nextSubStep}
                  prevStep={prevSubStep}
                  setDatosReserva={setDatosReserva}
                />
              )}

              {subStep === 2 && (
                <ReagendamientoReserva
                  nextStep={nextSubStep}
                  prevStep={prevSubStep}
                  datosReserva={datosReserva}
                />
              )}

              {subStep === 3 && (
                <div className="row" id="booking">
                <div className="container">
                  <div className="row mb40" id="booking-step-back">
                    <button className="volver-step1" onClick={prevSubStep}>
                      <i className="fa fa-long-arrow-left"></i>
                      &nbsp; VOLVER
                    </button>
                  </div>
                  <div className="row justify-content-center">
                    <div
                      className="col-md-3 col-12 mb40-768 pads0-768"
                      id="info-sidebar"
                    >
                      <Servicios />
                    </div>
                    <CalendarioReagendamiento
                      nextStep={nextSubStep}
                      prevStep={prevSubStep}
                      datosReserva={datosReserva}
                      setDatosReserva={setDatosReserva}
                    />
                    <div className="col-md-3 col-12 mt20-768" id="booking-resume">
                      <div className="row">
                        <div className="col-12 pads0 pads10-768 mobile-booking-tab-container">
                          <TiendaSeleccionadaReagendamiento 
                          datosReserva={datosReserva}/>
                          <ResumenExamenReagendamiento 
                          datosReserva={datosReserva}/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              )}

              {subStep === 4 && (
                <ResumenReagendamiento
                  nextStep={nextSubStep}
                  prevStep={prevSubStep}
                  datosReserva={datosReserva}
                  goToSubStep={goToSubStep}
                />
              )}
            </>
          )}

          {step === 8 && (
            <>
              {subStep === 1 && (
                <Reagendar
                  nextStep={nextSubStep}
                  prevStep={prevSubStep}
                  setDatosReserva={setDatosReserva}
                />
              )}
              {subStep === 2 && (
                <CancelarReserva
                  nextStep={nextSubStep}
                  prevStep={prevSubStep}
                  datosReserva={datosReserva}
                  setStep={setStep}
                  setSubStep={setSubStep}
                />
              )}
            </>
          )}
        </>
      ) : (
        <>
          {formData?.cadena === "opv" ? (
            <>
              {step === 1 && (
                <div className="container">
                  <div className="row">
                    <div className="row mb20" id="booking-intro-head">
                      <div className="col-12 pads30 pads10-768 mb20 mt20">
                        <div className="row d-flex align-items-center">
                          <div className="col-auto">
                            <img
                              src={selectedLogo}
                              alt="GMO logo"
                              className="img-fluid"
                              style={{ maxWidth: "290px", maxHeight: "30px" }}
                            />
                          </div>
                          <div className="col">
                            <h1 className="upper monts-l">
                              <span className="monts-b">
                                Programe un examen de la vista
                              </span>{" "}
                              para usted y su familia
                            </h1>
                            <div className="h-seo-desc">
                              <h2>
                                Ubica tu sucursal y agenda tu examen de la vista
                              </h2>
                            </div>
                            <p>
                              Reserve su fecha y horario preferido en su tienda
                              más cercana
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              {step === 1 && (
                <div className="row mb20" id="booking-intro-head">
                  <InfoInicio />
                </div>
              )}
            </>
          )}

          {step >= 2 && (
            <div className="row" id="booking-header">
              <StepIndicator step={headerStep} />
            </div>
          )}

          {step === 1 && (
            <div className="row" id="step-find">
              <div className="container pads0-768">
                <div className="row">
                  <div className="col-12">
                    <div className="row justify-content-center">
                      <div className="col-md-4 mb40-768 pads0-768">
                        <Servicios />
                        {formData?.cadena === "gmo" ? (
                          <div className="row">
                            <div className="col-12 mb20">
                              <p className="mb0">
                                <i>
                                  Si ya tienes una cita agendada y necesitas
                                  reprogramarla o anularla, puedes hacerlo aquí:
                                </i>
                              </p>
                            </div>
                            <div className="col-6">
                              <div
                                className="src-button-gmo search-button search-button-resch upper"
                                onClick={() => goToStep(7)}
                              >
                                Reagendar cita
                              </div>
                            </div>
                            <div className="col-6">
                              <div
                                className="src-button-gmo search-button search-button-cancel upper"
                                onClick={() => goToStep(8)}
                              >
                                Anular cita
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="col-md-8 col-12 pads0">
                        <div className="row mb20">
                          <BusquedaTiendaV2
                            onProgramarExamen={nextStep}
                            actualizarMapaCenter={actualizarMapaCenter}
                          />
                          <MapaGoogle
                            center={mapaCenter}
                            marcador={marcadorRef.current}
                          />
                        </div>

                        {formData?.cadena === "opv" ? (
                          <div className="row justify-content-center mb40">
                            <div className="col-md-9 col-12 mb20 text-center">
                              <p class="mb0">
                                <i>
                                En caso de tener una <b>cita agendada</b> y
                                  querer <b>reprogramarla o anularla</b>, puedes hacerlo aquí
                                </i>
                              </p>
                            </div>
                            <div className="col-md-4 col-6">
                              <div
                                className="src-button search-button search-button-resch upper button-opv"
                                onClick={() => goToStep(7)}
                              >
                                Reagendar cita
                              </div>
                            </div>
                            <div className="col-md-4 col-6">
                              <div
                                className="src-button search-button search-button-cancel upper button-opv"
                                onClick={() => goToStep(8)}
                              >
                                Anular cita
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {step > 1 && step < 5 && (
            <div className="row" id="booking">
              <div className="container">
                <div className="row mb40" id="booking-step-back">
                  <button className="volver-step1" onClick={prevStep}>
                    <i className="fa fa-long-arrow-left"></i>
                    &nbsp; VOLVER
                  </button>
                </div>
                <div className="row justify-content-center">
                  <div
                    className="col-md-3 col-12 mb40-768 pads0-768"
                    id="info-sidebar"
                  >
                    <Servicios />
                  </div>

                  {step === 2 && (
                    <PropositoCita onPropositoSeleccionado={nextStep} />
                  )}
                  {step === 3 && (
                    <Calendario onCalendarioSeleccionado={nextStep} />
                  )}
                  {step === 4 && (
                    <DatosPersonales onDatosPersonalesSeleccionado={nextStep} />
                  )}

                  <div className="col-md-3 col-12 mt20-768" id="booking-resume">
                    <div className="row">
                      <div className="col-12 pads0 pads10-768 mobile-booking-tab-container">
                        <TiendaSeleccionada />
                        {step === 3 || step === 4 ? <ResumenExamen /> : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {step === 5 && (
            <div className="row" id="booking">
              <div className="container">
                <div className="row mb40" id="booking-step-back">
                  <button className="volver-step1" onClick={prevStep}>
                    <i className="fa fa-long-arrow-left"></i>
                    &nbsp; VOLVER
                  </button>
                </div>
                <div className="row justify-content-center">
                  <Resumen
                    onResumenSeleccionado={nextStep}
                    onVolver={prevStep}
                  />
                </div>
              </div>
            </div>
          )}

          {step === 7 && (
            <>
              {subStep === 1 && (
                <Reagendar
                  nextStep={nextSubStep}
                  prevStep={prevSubStep}
                  setDatosReserva={setDatosReserva}
                />
              )}

              {subStep === 2 && (
                <ReagendamientoReserva
                  nextStep={nextSubStep}
                  prevStep={prevSubStep}
                  datosReserva={datosReserva}
                />
              )}

              {subStep === 3 && (
                <div className="row" id="booking">
                  <div className="container">
                    <div className="row mb40" id="booking-step-back">
                      <button className="volver-step1" onClick={prevSubStep}>
                        <i className="fa fa-long-arrow-left"></i>
                        &nbsp; VOLVER
                      </button>
                    </div>
                    <div className="row justify-content-center">
                      <div
                        className="col-md-3 col-12 mb40-768 pads0-768"
                        id="info-sidebar"
                      >
                        <Servicios />
                      </div>
                      <CalendarioReagendamiento
                        nextStep={nextSubStep}
                        prevStep={prevSubStep}
                        datosReserva={datosReserva}
                        setDatosReserva={setDatosReserva}
                      />
                      <div className="col-md-3 col-12 mt20-768" id="booking-resume">
                        <div className="row">
                          <div className="col-12 pads0 pads10-768 mobile-booking-tab-container">
                            <TiendaSeleccionadaReagendamiento 
                            datosReserva={datosReserva}/>
                            <ResumenExamenReagendamiento 
                            datosReserva={datosReserva}/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {subStep === 4 && (
                <ResumenReagendamiento
                  nextStep={nextSubStep}
                  prevStep={prevSubStep}
                  datosReserva={datosReserva}
                  goToSubStep={goToSubStep}
                />
              )}
            </>
          )}

          {step === 8 && (
            <>
              {subStep === 1 && (
                <Reagendar
                  nextStep={nextSubStep}
                  prevStep={prevSubStep}
                  setDatosReserva={setDatosReserva}
                />
              )}
              {subStep === 2 && (
                <CancelarReserva
                  nextStep={nextSubStep}
                  prevStep={prevSubStep}
                  datosReserva={datosReserva}
                  setStep={setStep}
                  setSubStep={setSubStep}
                />
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default Reserva;
